import {} from 'react';

import Card from 'components/Card/Card';

import PeriodsTable from './PeriodsTable/PeriodsTable';

import './Grades.scoped.scss';

const Grades: React.FC = () => {
  return (
    <div className="grades-container">
      <Card className="mobile" style={{}}>
        <Card.Body
          style={{
            maxWidth: 'calc(100% - 40px)',
            minHeight: 'calc(100vh - 170px)',
          }}
        >
          <div className="card-body-wrapper">
            <PeriodsTable />
          </div>
        </Card.Body>
      </Card>
    </div>
  );
};

export default Grades;
